import { FireBaseService } from "shared/services";

export class UserScoreService {
    public static changeScore(score) {
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        user.score = user.score + score;
        localStorage.setItem('mbny_game_user', JSON.stringify(user));
        // return FireBaseService.firestore.collection('users').doc(user.id).update({
        //     score: user.score,
        // })
    }
}